import { render, staticRenderFns } from "./StatistiqueRegie.vue?vue&type=template&id=286bd656&scoped=true&"
import script from "./StatistiqueRegie.vue?vue&type=script&lang=js&"
export * from "./StatistiqueRegie.vue?vue&type=script&lang=js&"
import style0 from "./StatistiqueRegie.vue?vue&type=style&index=0&id=286bd656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286bd656",
  null
  
)

export default component.exports